import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=2863c146&scoped=true"
import script from "./PlanForm.vue?vue&type=script&lang=js"
export * from "./PlanForm.vue?vue&type=script&lang=js"
import style0 from "./PlanForm.vue?vue&type=style&index=0&id=2863c146&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863c146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2863c146')) {
      api.createRecord('2863c146', component.options)
    } else {
      api.reload('2863c146', component.options)
    }
    module.hot.accept("./PlanForm.vue?vue&type=template&id=2863c146&scoped=true", function () {
      api.rerender('2863c146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/fees/PlanForm.vue"
export default component.exports